'use client'

import { formatDurationCountdown } from '@/lib/countdown'
import { CalendarClock } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'

export default function ScheduledPreviewBanner({ championship }) {
  const [now, setNow] = useState(null)

  const releaseAt = useMemo(() => {
    if (!championship?.reviewedTs || !championship?.releaseDateTime) return null

    const value = new Date(championship.releaseDateTime).getTime()
    return Number.isNaN(value) ? null : value
  }, [championship?.releaseDateTime, championship?.reviewedTs])

  useEffect(() => {
    if (!releaseAt) return

    const currentNow = Date.now()
    setNow(currentNow)

    if (releaseAt <= currentNow) return

    const intervalId = window.setInterval(() => {
      const nextNow = Date.now()
      setNow(nextNow)

      if (releaseAt <= nextNow) {
        window.clearInterval(intervalId)
      }
    }, 1000)

    return () => window.clearInterval(intervalId)
  }, [releaseAt])

  if (!releaseAt || !now || releaseAt <= now) return null

  return (
    <div className="screen-grid mt-6">
      <div className="grid-indent rounded-sm border border-primary-500/40 bg-primary-500/10 p-4">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <CalendarClock className="mt-0.5 size-5 shrink-0 stroke-primary-300" />
            <div>
              <p className="text-p-1 font-semibold text-primary-100">
                Manager preview: this page is not live yet
              </p>
              <p className="mt-1 text-p-2 text-neutral-blue-200">
                Drivers will be able to access it at{' '}
                {new Date(releaseAt).toLocaleString()}.
              </p>
            </div>
          </div>

          <div className="rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 px-4 py-2 text-left sm:text-right">
            <p className="text-p-3 font-medium text-neutral-blue-300">
              Goes Live In
            </p>
            <p className="text-p-1 font-semibold text-shades-0">
              {formatDurationCountdown(releaseAt - now)}
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
